import InputSearch from "./inputSearch"


import { useAppDispatch } from "../../redux"
import { useTranslation } from "react-i18next"
import { activeFilterPharmacies, searchLoadPharmacies, updatePageIndex } from "../../redux/reducer/pharmaciesReducer"
const PharmaciesFilter = (props: any) => {

  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const setSearch = (input: string) => {
    dispatch(updatePageIndex(1))
    dispatch(searchLoadPharmacies(input))
  }



  return (
    <div className="Filter">
      <div className="row m-0">
        <div className="col-lg-8 pt-4">
        </div>
        <div className="col-lg-4 pt-4 text-lg-right">
          <InputSearch placeholder={t('search')} handleClick={(e: any) => { setSearch(e); }} />
        </div>
      </div>
    </div>
  )
}

export default PharmaciesFilter